var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-data-chips",
    {
      attrs: {
        label: _vm.label,
        color: _vm.technician.scheduled ? "success--text" : "",
        value: _vm.technician.full_name,
        loading: _vm.loading
      },
      on: {
        click: function($event) {
          return _vm.$emit("click", _vm.technician)
        }
      }
    },
    [
      _c("custom-simple-table", {
        attrs: {
          item: _vm.transformedItem,
          "i18-path": "tech_search.fields",
          "table-keys": _vm.technicianTableKeys
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }